// extracted by mini-css-extract-plugin
module.exports = {"container":"popularLocations-module--container--1Az_C","heading":"popularLocations-module--heading--3IZ7b"};